import { useEffect, useRef } from "react";

export const useBodyLock = (isOpen: boolean) => {
  const savedScrollYRef = useRef(0);

  useEffect(() => {
    if (!isOpen) return;

    const body = document.body;

    savedScrollYRef.current = window.scrollY;

    const previousStyles = {
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
      overflow: body.style.overflow,
    };

    body.style.position = 'fixed';
    body.style.top = `-${savedScrollYRef.current}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    return () => {
      body.style.position = previousStyles.position;
      body.style.top = previousStyles.top;
      body.style.width = previousStyles.width;
      body.style.overflow = previousStyles.overflow;
      window.scrollTo(0, savedScrollYRef.current);
    };
  }, [isOpen]);
};
